import { ChangeReassignUserPayload, FillReassignUserPayload, ReassignUserReducerState } from "../types";

export const fillReassignRow = (state: ReassignUserReducerState, payload: FillReassignUserPayload): ReassignUserReducerState => {
    return { ...state, reassignRow: payload.row }
}

export const changeReassignUserId = (state: ReassignUserReducerState, payload: ChangeReassignUserPayload): ReassignUserReducerState => {
    return { ...state, userToReassignId: payload.userId }
}